import { FeeTableCard } from "@/components/admin/FeeTableCard";
import { Switch } from "@/components/ui/switch";

export const CustomCalcs = ({ c, save }) => {
  const list = c.custom_calcs || [];
  if (!list.length) return null;
  const othersOn = c.general_enabled !== false || c.cruise_enabled || c.fishing_enabled || c.leisure_enabled || (c.other_enabled && c.other_groups.some((g) => g.types.length));
  const activeCount = list.filter((x) => x.enabled !== false).length;
  const isLast = (x) => !othersOn && x.enabled !== false && activeCount <= 1;
  const setAt = (i, x, delay) => save("custom_calcs", list.map((y, j) => (j === i ? x : y)), delay);
  return (
    <div className="space-y-4 pt-4" data-testid="custom-calcs">
      <div>
        <h3 className="font-display text-lg font-semibold text-slate-900">Egne valg i nedtrekkslisten</h3>
        <p className="text-xs text-slate-500">Hver tabell vises som egen fartøytype i kalkulatoren. ISPS og avfallsgebyr stilles inn under «Fartøytyper».</p>
      </div>
      {list.map((x, i) => {
        const on = x.enabled !== false;
        return (
          <div key={x.id} className="space-y-2" data-testid={`custom-calc-${x.id}`}>
            <label className={`flex items-center justify-between gap-3 rounded-md border px-4 py-2.5 ${on ? "border-emerald-200 bg-emerald-50/60" : "border-slate-200 bg-slate-50"} ${isLast(x) ? "cursor-not-allowed" : "cursor-pointer"}`}>
              <span className="text-sm">
                <span className="font-medium text-slate-900">{on ? "Vises i nedtrekkslisten" : "Skjult i kalkulatoren"}</span>
                <span className="block text-xs text-slate-500">{isLast(x) ? "Minst én kalkulator må være slått på." : "Prisene beholdes når tabellen er skjult."}</span>
              </span>
              <Switch checked={on} disabled={isLast(x)} onCheckedChange={(v) => setAt(i, { ...x, enabled: v }, 0)} data-testid={`custom-calc-${x.id}-enabled`} />
            </label>
            <div className={on ? "" : "opacity-60"}>
              <FeeTableCard table={x.table} unit={x.basis === "length" ? "meter" : "BT"} canDelete={!isLast(x) && (othersOn || list.length > 1)}
                badge={`${x.basis === "length" ? "Etter lengde (meter)" : "Etter brutto tonnasje"}${on ? "" : " · skjult"}`}
                onChange={(t) => setAt(i, { ...x, table: t })} onDelete={() => save("custom_calcs", list.filter((_, j) => j !== i), 0)} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
